/* eslint-disable */
import { Injectable } from '@angular/core';
import { Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApplicationProxyService } from '../shared/services/applicationproxy.service';
import { DTMService } from '../shared/services/dtm.service';
import { FlowManagerService } from '../shared/services/flowmanager.service';
import { LoggerService } from '../shared/services/logger.service';

@Injectable()
export class DTMGuard implements CanActivateChild {
	constructor(
    appProxy: ApplicationProxyService,
    dtm: DTMService,
    flowManager: FlowManagerService,
    router: Router,
    logService: LoggerService) {
    this.dtm = dtm;
    this.flowManager = flowManager;
    this.router = router;
    this.logService = logService;
    this.appProxy = appProxy;
  }

  // Dont block route execution but still have the DTM log not fire until we have a guid (SessionId)
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this._logRoute(route);
    return true;
  }

  async _waitForSessionId() {
    if (this.flowManager.guid == null || this.flowManager.guid === '') {
      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      await sleep(100);
      return this._waitForSessionId();
    }

    return true;
  }

  async _waitForExperiments() {
    const expObj = this.flowManager.dtmExperiments;
    if (Object.keys(expObj).length === 0) {
      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      await sleep(100);
      return this._waitForExperiments();
    }

    return true;
  }

  async _hasExperiments(page) {
    const payload = {
      appType: this.flowManager.getAppType(),
      page
    }
    return this.appProxy.hasExperiments(payload).then(value => {
      this.flowManager.hasExperiments = value;
    });
  }

  async _logRoute(route) {
    // Set the new data
    let url = route.url;
    if (route.url[0] === undefined) url = 'get-started';
    const urlPath = url[0].path || url;

    await this._hasExperiments(urlPath);
    if (this.flowManager.hasExperiments) {
      await this._waitForSessionId();
      await this._waitForExperiments();
    }

    const routeConfig = route.routeConfig;
    if (routeConfig.resolve === undefined || routeConfig.resolve.formData === undefined) {
      this.logService.logPageLoad(route);
    }
  }
}
